// SVG ICONS
const svg = {
    arrow_right: '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" fill="none"><path d="M517.85-480 354.92-642.92q-8.3-8.31-8.5-20.89-.19-12.57 8.5-21.27 8.7-8.69 21.08-8.69 12.38 0 21.08 8.69l179.77 179.77q5.61 5.62 7.92 11.85 2.31 6.23 2.31 13.46t-2.31 13.46q-2.31 6.23-7.92 11.85L397.08-274.92q-8.31 8.3-20.89 8.5-12.57.19-21.27-8.5-8.69-8.7-8.69-21.08 0-12.38 8.69-21.08L517.85-480Z" fill="currentColor"/></svg>',
};

// 1 REM IN PX
function getRemInPx() {
    return parseFloat(getComputedStyle(document.documentElement).fontSize);
}

// REM -> PX
function remToPx(rem) {
    return rem * getRemInPx();
}

// PX -> REM
function pxToRem(px) {
    return px / getRemInPx();
}

$(function () {

    let contactFormPhoneMask = null;

    // SEARCH [START]
    $('.fn_search_input').autocomplete({
        serviceUrl: 'ajax/search',
        minChars: 1,
        noCache: true,
        appendTo: '#fn_search',
        // onSelect: function (suggestion) {
        //     if (suggestion && suggestion.data && suggestion.data.url) {
        //         window.location.href = suggestion.data.url;
        //     }
        // },
        formatResult: function (suggestion, currentValue) {
            const url  = suggestion.data.url;
            const name = suggestion.value;

            const pattern = '(' + $.Autocomplete.utils.escapeRegExChars(currentValue) + ')';
            const regex   = new RegExp(pattern, 'gi');

            const highlighted = name.replace(regex, '<strong>$1</strong>');

            return (
                '<a href="' + url + '" class="autocomplete-suggestion__link">' +
                    '<span class="autocomplete-suggestion__name">' + highlighted + '</span>' +
                    '<span class="autocomplete-suggestion__arrow">' + svg.arrow_right + '</span>' +
                '</a>'
            );
        }
    });
    // SEARCH [END]

    // MASK: PHONE [START]
    $('input[name="phone"]').each(function () {
        const $input = $(this);
        let phoneCountryBlock = document.querySelector('.fn_phone_country');

        contactFormPhoneMask = IMask(this, {
            mask: phoneMasks,
            dispatch: function (appended, dynamicMasked) {
                const number = (dynamicMasked.value + appended).replace(/\D/g, '');
                let foundMask = dynamicMasked.compiledMasks.find(m =>
                    m.startsWith && number.indexOf(m.startsWith) === 0
                );

                // FALLBACK MASK
                if (!foundMask) {
                    foundMask = dynamicMasked.compiledMasks[dynamicMasked.compiledMasks.length - 1];
                }

                $input.data('mask', foundMask.mask);
                $input.data('country', foundMask.country);

                if (phoneCountryBlock) {
                    phoneCountryBlock.textContent = countryNames[foundMask.country];
                }

                return foundMask;
            },
            lazy: false,
            placeholderChar: '_',
        });
    });
    // MASK: PHONE [END]

    // RATING [START]
    let isRatingProcessing = false;

    $(this).on('click', '.fn_rating', function () {

        const $btn     = $(this);
        const $votes   = $btn.find('.fn_rating_votes');
        const id       = $btn.data('id');
        const type     = $btn.data('type');
        const vote     = $btn.data('vote');
        const voted    = $btn.data('voted');
        const rating   = 5;
        const isActive = $btn.hasClass('active');

        if (!id || !type || isActive || isRatingProcessing) return false;

        isRatingProcessing = true;

        const ratingId = type + '_' + id;

        let ajax = $.ajax({
            method: 'POST',
            url: 'ajax/rating',
            data: {
                id: ratingId,
                rating: rating,
            },
        });

        ajax.done(function (data) {
            if (data && data.votes) {
                $votes.html(data.votes);
            }

            $btn.attr('title', voted);
            $btn.addClass('active');
        });

        ajax.fail(function () {
            $btn.attr('title', vote);
            $btn.removeClass('active');
        });

        ajax.always(function () {
            isRatingProcessing = false;
        });

        return false;

    });
    // RATING [END]

    // SEND CONTACT FORM AJAX [START]
    let isContactFormProcessing = false;

    function sendContactFormAjax(form) {
        const $form      = $(form);
        const formAction = $form.attr('action') + '?ajax=1';
        const formMethod = $form.attr('method') || 'POST';
        const formData   = new FormData(form);

        if (isContactFormProcessing) return false;

        isContactFormProcessing = true;

        $.ajax({
            url:         formAction,
            method:      formMethod,
            data:        formData,
            dataType:    'json',
            processData: false,
            contentType: false,
        })
        .done(function (data) {
            if (data && data.success) {
                contactFormSuccess();

                $form[0].reset();
                resetContactFormFile();
                contactFormPhoneMask.updateValue();
            } else {
                contactFormError();
            }
        })
        .fail(function () {
            contactFormError();
        })
        .always(function () {
            isContactFormProcessing = false;
        });
    }

    const $form             = $('.fn_contact_form');
    const $formVariantId    = $form.find('select[name="variant_id"]');
    const $formFile         = $('.fn_form_file');
    const $formFileInput    = $formFile.find('.fn_form_file_input');
    const $formFileEmpty    = $formFile.find('.fn_form_file_empty');
    const $formFileSelected = $formFile.find('.fn_form_file_selected');
    const $formFileName     = $formFile.find('.fn_form_file_name');

    $formVariantId.on('change', function () {
        const url = $(this).find('option:selected').data('url');
        $form.attr('action', url);
    });

    $formFileInput.on('change', function () {
        const file = this.files[0];
        if (file) {
            $formFileName.text(file.name);
            $formFileEmpty.hide();
            $formFileSelected.show();
        } else {
            resetContactFormFile();
        }
    });

    $formFileSelected.on('click', '.fn_form_file_remove', function () {
        resetContactFormFile();
    });

    function resetContactFormFile() {
        $formFileInput.val('');
        $formFileSelected.hide();
        $formFileEmpty.show();
    }
    // SEND CONTACT FORM AJAX [END]

    // POPUP: CONTACT FORM SUCCESS [START]
    function contactFormSuccess() {
        Fancybox.show([{
            src: '#contact-form-success',
            type: 'inline',
        }]);

        setTimeout(function () {
            Fancybox.close();
        }, 3500);
    }
    // POPUP: CONTACT FORM SUCCESS [END]

    // POPUP: CONTACT FORM ERROR [START]
    function contactFormError() {
        Fancybox.show([{
            src: '#contact-form-error',
            type: 'inline',
        }]);

        setTimeout(function () {
            Fancybox.close();
        }, 3500);
    }
    // POPUP: CONTACT FORM ERROR [END]

    // VALIDATE [START]
    $.validator.addMethod('phoneValidation', function(value, element) {
        if (!value) return false;

        const $el = $(element);
        const number = value.replace(/\D/g, '');
        const mask = $el.data('mask');

        if (!mask) return false;

        const expectedDigits = mask.replace(/\D/g, '').length;

        return number.length === expectedDigits;
    }, 'Введіть коректний номер телефону');

    $('.fn_contact_form').validate({
        rules: {
            name: 'required',
            email: {
                required: true,
                email: true,
            },
            phone: {
                required: true,
                phoneValidation: true,
            },
            variant_id: 'required',
            'requisites[model]': 'required',
            'requisites[os]': 'required',
            comment: 'required',
        },
        messages: {
            name: "Введіть Ваше ім'я",
            email: {
                required: "Введіть Email",
                email: "Введіть коректний Email",
            },
            phone: {
                required: "Введіть номер телефону",
                phoneValidation: "Введіть коректний номер телефону",
            },
            variant_id: "Оберіть тип звернення",
            'requisites[model]': "Вкажіть виробника та модель пристрою",
            'requisites[os]': "Вкажіть операційну систему та версію",
            comment: "Опишіть суть звернення"
        },
        submitHandler: function (form) {
            sendContactFormAjax(form);
            return false;
        },
        errorElement: 'span',
        errorPlacement: function(error, element) {
            error.addClass('contact-form__error');
            element.parent().append(error);
        },
    });
    // VALIDATE [END]

    // SWIPER: BREADCRUMBS [START]
    if ($('.fn_swiper_breadcrumbs').length > 0) {
        function toggleGradientClasses(sw) {
            const $el = $(sw.el);
            $el.toggleClass('at-start', !sw.isBeginning);
            $el.toggleClass('at-end', !sw.isEnd);
        }

        let swiperBreadcrumbs = new Swiper('.fn_swiper_breadcrumbs', {
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            spaceBetween: 0,
            navigation: false,
            pagination: false,
            on: {
                init:         function () { toggleGradientClasses(this); },
                setTranslate: function () { toggleGradientClasses(this); },
                resize:       function () { toggleGradientClasses(this); },
            },
        });
    }
    // SWIPER: BREADCRUMBS [END]

    // SCROLL TO ANCHOR [START]
    $(this).on('click', '.fn_anchor', function (e) {
        const $link  = $(this);
        const href   = $link.attr('href');
        let targetId = null;

        if (href) {
            const parts = href.split('#');
            if (parts.length > 1) {
                targetId = '#' + parts[1];
            }
        } else {
            const dataTarget = $link.data('target');
            if (dataTarget) {
                targetId = '#' + dataTarget;
            }
        }

        if (targetId) {
            const $target      = $(targetId);
            const indent       = remToPx(1)
            const headerHeight = $('.header').outerHeight() || 0;

            if ($target.length) {
                e.preventDefault();
                $('html, body').animate({
                    scrollTop: $target.offset().top - (headerHeight + indent)
                }, 600);
            }
        }
    });
    // SCROLL TO ANCHOR [END]

});